module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNTEyLjAwNXY1MTIuMDA1SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjYWIyMzFkIiBkPSJNMCAwaDUxMi4wMDV2MjA0LjgwMkgwek0wIDMwNy4yMDNoNTEyLjAwNXYyMDQuODAySDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/lv.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/lv.svg
// module chunks = 0